import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import PaymentIcon from "@mui/icons-material/Payment";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useHistory } from "react-router-dom";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import GifLoader from "../components/ui/gifLoader";
// context
import { NotificacionContext } from "../context/notificacion_context";
//pdf
import CapturaContext from "../context/captura_context/capturaContext";
import PaymentsIcon from "@mui/icons-material/Payments";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { InputAdornment, Modal, TextField } from "@mui/material";
import { services } from "../services/api";
import swal from "sweetalert";

const colorUI = "#6f1d46";
// const colorUI="#8d949e";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#005cbf"),
  backgroundColor: colorUI,
  "&:hover": {
    backgroundColor: colorUI,
  },
}));

const ColorButtonSecond = styled(Button)(({ theme }) => ({
  color: colorUI,
  backgroundColor: "#ffc3d0",
  border: "none",
  "&:hover": {
    transform: "scale(1.005)",
    boxShadow: "3px 3px 6px 0px rgba(0, 0, 0, 0.2)",
  },
}));

const Captura = () => {
  const history = useHistory();
  const capturactx = useContext(CapturaContext);
  const [state, setState] = useState({
    error: false,
  });
  const [loadingPdf, setLoadingPdf] = useState(true);

  const [modalShow, setModalShow] = useState(false);
  const [montoRecibido, setMontoRecibido] = useState("");
  const [errorMonto, setErrorMonto] = useState("");
  const [loader, setloader] = useState(false);
  const [lineaCapPagada, setlineaCapPagada] = useState(null);
  const { pago_linea } = capturactx;
  const pdfFake = "";
  const {
    CONCEPTOPLINEA,
    FECHAPLINEA,
    FORMATO,
    IMPORTE,
    LINEA_CAPTURA,
    URLRETORNO,
    NOMBRE,
  } = pago_linea;

  const TOKEN = pago_linea.TOKEN ? pago_linea.TOKEN : "";
  const { showNotification } = useContext(NotificacionContext);

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "60%",
    p: 4,
  };

  const closeModal = (value) => {
    setModalShow(value);
  };

  localStorage.removeItem("tokenPago");

  const regresar = () => {
    history.replace("/home");
  };

  const verificarPago = () => {
    if (parseInt(IMPORTE) >= 50000) {
      showNotification(
        "error",
        "Compra Declinada",
        "No se aceptan pagos PINPAD mayores a $50,000",
        null,
        4
      );
      return;
    }
    localStorage.setItem("lineaCaptura", LINEA_CAPTURA);
    localStorage.setItem("importe", IMPORTE);

    const referencia = localStorage.getItem("lineaCaptura");
    if (referencia) {
      window.open(`/verificarPago/${referencia}`, "_blank", 'noopener');
    } else {
      history.push("/");
    }
  };

  const { usuario_pinpad, password_pinpad, cajaChica, rol } = JSON.parse(
    localStorage.getItem("usuario")
  );
  const serial = localStorage.getItem("serial");

  const handleChangeMonto = (e) => {
    const value = e.target.value;

    const numericValue = value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*)\./g, "$1");

    const monto = parseFloat(numericValue);
    const importe = parseFloat(IMPORTE);

    if (!isNaN(monto) && monto < importe) {
      setErrorMonto(
        "El monto recibido debe ser igual o mayor al monto a pagar"
      );
    } else {
      setErrorMonto("");
    }

    if (numericValue.length <= 10) {
      setMontoRecibido(numericValue);
    }
  };

  const pagar = async () => {
    setloader(true);

    const importe = parseFloat(IMPORTE);
    const recibido = parseFloat(montoRecibido);

    if (isNaN(recibido) || recibido < importe) {
      setErrorMonto(
        "El monto recibido debe ser igual o mayor al monto a pagar"
      );
      setloader(false);
      return;
    } else {
      setErrorMonto("");

      const bodySend = {
        linea_captura: LINEA_CAPTURA,
        monto: Number(IMPORTE),
      };

      const response = await services("POST", "cajaChica/acreditar", bodySend);

      if (response.status === 200) {
        closeModal(false);
        setMontoRecibido("");
        setErrorMonto("");
        setlineaCapPagada(response?.data?.data?.pdf);

        swal({
          title: "El pago se realizó con éxito",
          text: `El cambio es de $${montoRecibido === ""
            ? 0
            : Math.max(0, Number(montoRecibido) - Number(IMPORTE))
            }`,
          icon: "success",
          button: "Aceptar",
        });
        document.querySelector(".swal-button--confirm").style.backgroundColor =
          colorUI;
      } else {
        showNotification(
          "error",
          "Error de pago",
          "Ha ocurrio un error con el pago, por favor vuelva a intentarlo de nuevo",
          null,
          4
        );
        closeModal(false);
        setMontoRecibido("");
      }
      setloader(false);
    }
  };

  return (
    <>
      {loader ? <GifLoader /> : null}
      <div className=" h-100">
        {!FORMATO && !lineaCapPagada ? (
          regresar()
        ) : (
          <Container maxWidth="md">
            {lineaCapPagada ? null : (
              <Box sx={{ height: "auto", paddingTop: "6%" }}>
                <Box>
                  <Grid
                    container
                    spacing={1}
                    sx={{ justifyContent: "center", alignItems: "center" }}
                  >
                    {/* <Grid item xs="auto" >
                                      <ColorButtonSecond variant="outlined" onClick={() => { regresar() }} endIcon={<KeyboardReturnIcon />} >Regresar </ColorButtonSecond>
                                  </Grid> */}
                    <Grid item xs="auto">
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href={FORMATO ? `${FORMATO}/2` : pdfFake}
                      >
                        <ColorButtonSecond
                          variant="outlined"
                          endIcon={<CloudDownloadIcon />}
                        >
                          {" "}
                          Descargar mi formato de pago
                        </ColorButtonSecond>
                      </a>
                    </Grid>
                    <Grid item xs="auto">
                      <form
                        action={process.env.REACT_APP_URLPAGO}
                        method="post"
                      >
                        <input
                          type="hidden"
                          name="concepto"
                          value={CONCEPTOPLINEA}
                        />
                        <input
                          type="hidden"
                          name="usuario"
                          value={NOMBRE}
                        />
                        <input
                          type="hidden"
                          name="lcaptura"
                          value={LINEA_CAPTURA}
                        />
                        <input type="hidden" name="monto" value={IMPORTE} />

                        <input
                          type="hidden"
                          name="fecha_vencimiento"
                          value={FECHAPLINEA}
                        />
                        <input type="hidden" name="tkn" value={TOKEN} />
                        {/* <input type="hidden" name="urlDiversos" value={process.env.REACT_APP_URLREDIRECT}/> */}
                        <input
                          type="hidden"
                          name="urlDiversos"
                          // value={URLRETORNO}
                          value="https://hola.com"
                        />
                        <input
                          type="hidden"
                          name="urlRetorno"
                          value={URLRETORNO}
                        />
                        <input type="hidden" name="email" value="" />

                        <div className="d-flex justify-content-center align-items-center">
                          <ColorButton
                            variant="outlined"
                            type="submit"
                            endIcon={<PaymentIcon />}
                          >
                            Pagar en Línea
                          </ColorButton>

                          {usuario_pinpad &&
                            password_pinpad &&
                            serial === "1" && (
                              <ColorButton
                                className="ms-2"
                                variant="outlined"
                                onClick={verificarPago}
                                endIcon={<PaymentsIcon />}
                              >
                                {" "}
                                Pagar con PinPad
                              </ColorButton>
                            )}

                          {(rol === "Administrador" || rol === "Ventanilla") &&
                            cajaChica === 1 ? (
                            <ColorButton
                              className="ms-2"
                              variant="outlined"
                              onClick={() => closeModal(true)}
                              endIcon={<RequestQuoteIcon />}
                            >
                              {" "}
                              Pago en efectivo
                            </ColorButton>
                          ) : null}
                        </div>
                      </form>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
            <div className="pt-2 border-bottom--guinda text-big mb-2 text-bold">
              {lineaCapPagada ? "Pago realizado" : "Formato de pago"}
            </div>

            {!lineaCapPagada && !state.error ? (
              <>
                {loadingPdf && (
                  <div className="d-flex justify-content-center align-items-center py-3">
                    <p>Cargando PDF...</p>
                  </div>
                )}
                <div className="d-flex justify-content-center align-items-center py-3 vh-100">
                  <object
                    data={FORMATO}
                    type="application/pdf"
                    height="100%"
                    width="100%"
                    onLoad={() => setLoadingPdf(false)}
                  ></object>
                </div>
              </>
            ) : null}

            {lineaCapPagada && (
              <>
                {loadingPdf && (
                  <div className="d-flex justify-content-center align-items-center py-3">
                    <p>Cargando PDF...</p>
                  </div>
                )}
                <div className="d-flex justify-content-center align-items-center py-3 vh-100">
                  <object
                    data={lineaCapPagada}
                    type="application/pdf"
                    height="100%"
                    width="100%"
                    onLoad={() => setLoadingPdf(false)}
                  ></object>
                </div>
              </>
            )}
          </Container>
        )}
      </div>

      {/* Modal permitir pagos en efectivo*/}
      <Modal
        open={modalShow}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <h2 className="mb-4 text-center">Detalles de pago en efectivo</h2>

          <div className="d-flex gap-4 mb-2 w-100">
            <TextField
              id="standard-basic"
              name="convenio"
              className="w-100"
              disabled
              value={NOMBRE}
              label="Nombre"
              variant="standard"
            />
            <TextField
              id="standard-basic"
              name="convenio"
              className="w-100"
              disabled
              value={LINEA_CAPTURA}
              label="Referencia"
              variant="standard"
            />
          </div>

          <div className="d-flex gap-4 mb-2 w-100">
            <TextField
              id="standard-basic"
              className="w-100"
              name="convenio"
              disabled
              value={IMPORTE}
              label="Monto a pagar"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              variant="standard"
            />
            <TextField
              id="standard-basic"
              className="w-100"
              name="convenio"
              onChange={handleChangeMonto}
              value={montoRecibido}
              placeholder="0"
              error={!!errorMonto}
              helperText={errorMonto}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              label="Monto recibido"
              variant="standard"
            />
          </div>

          <div className="d-flex flex-column-reverse mt-4 flex-md-row gap-3 gap-md-0 justify-content-between">
            <ColorButton
              className="bg-danger"
              variant="outlined"
              onClick={() => {
                closeModal(false);
                setMontoRecibido("");
                setErrorMonto("");
              }}
            >
              Cerrar
            </ColorButton>
            <ColorButton
              endIcon={<AttachMoneyIcon />}
              variant="outlined"
              onClick={pagar}
            >
              Pagar
            </ColorButton>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Captura;
